<script setup>
import Lucide from "@/base-components/Lucide";
import {useFetch} from "@/composables/useFetch.js";
import {onMounted, ref} from "vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";
import {useRoute, useRouter} from "vue-router";
import {uri} from "@/constants/config.js";
import "vue-awesome-paginate/dist/style.css";
import BasePagination from "@/base-components/Table/BasePagination.vue";
import {useI18n} from "vue-i18n";
import Button from "@/base-components/Button";
import cloudComputingImage from "@/assets/images/graph/cloud-computing.png";

const {t: $t} = useI18n()
const route = useRoute()
const router = useRouter()
const dataList = ref([])
const isLoadingFlag = ref(true)
const cols = [
  {field: "counter", title: "#"},
  {field: "name", title: $t('title.name')},
  {field: "setting", title: $t('title.setting')},
]
const pageOptions = ref({
  count: 1,
  limit: 10,
  page: 1
})


const loadList = async () => {
  isLoadingFlag.value = true

  try {
    const {
      data,
      error
    } = await useFetch(`${uri.admin.rbac.routes.list}?page=${pageOptions.value.page}`, {method: "GET"});
    if (!error) {
      dataList.value = data.data
      pageOptions.value.count = data.meta.total
      pageOptions.value.limit = data.meta.perPage
    } else {
      console.error(error)
    }
  } catch (err) {
    console.log(err)
  } finally {
    isLoadingFlag.value = false
  }
}
async function addRoutes() {
  isLoadingFlag.value = true
  await useFetch(uri.admin.rbac.routes.list, {method: "POST"})
  await loadList()
}

async function rowClick(row) {
  await useFetch(uri.admin.rbac.add, {
    body: {
      name: row.value,
      type: "PERMISSION",
      attributes: []
    }
  });

  return loadList()
}


// Fetch data when the component mounts
onMounted(loadList);

</script>
<template>
  <FreeStyleShimmer v-if="isLoadingFlag" height="400px" width="100%" class="m-5"/>

  <div class="flex items-center justify-between border-b pb-2 mb-4 mt-4">
    <div class="w-36 -mt-3 flex flex-row gap-2">
      <Button variant="primary" size="sm" class="w-16" @click="addRoutes">
        {{ $t("button.addRoutes") }}
      </Button>
    </div>
  </div>
  <vue3-datatable
      :columns="cols"
      :rows="dataList"
      :loading="isLoadingFlag"
      :totalRows="pageOptions.count"
      :isServerMode="true"
      :pageSize="pageOptions.limit"
      :pagination="false"
      :sortable="false"
      class="advanced-table px-4 text-start items-start justify-start"
      rowClass="cursor-pointer"
  >
    <!-- Empty header slot to remove the header -->
    <template #header>
      <!-- No content here will hide the header -->
    </template>
    <!-- Empty footer slot to remove the footer -->
    <template #footer>
      <!-- No content here will hide the footer -->
    </template>

    <template #counter="data,key">
      <div class="text-start">
        {{
          (dataList.indexOf(data.value) + 1) + ((pageOptions.page - 1) * pageOptions.limit)
        }}
      </div>
    </template>

    <template #department="data,key">
      <div class="text-start">
        {{ data.value.Department.name }}
      </div>
    </template>

    <template #name="data,key">
      <div class="text-start">
        {{ data.value }}
      </div>
    </template>

    <template #setting="data,key">
      <div class="text-start">
        <Button variant="success" class="text-white" @click="rowClick(data)">
          <Lucide icon="PlusCircle" class="w-6 h-6 text-white inline-block ml-1"/>
          {{ $t("button.create") }}
        </Button>
      </div>
    </template>

  </vue3-datatable>
  <div
      class="flex flex-col items-center p-5 text-center sm:flex-row sm:text-left text-slate-500"
  >
    <div>

      <BasePagination
          v-if="pageOptions.count>pageOptions.limit"
          :page-options="pageOptions"
          @page-change="loadList"
      />
    </div>
    <div class="mt-2 sm:ml-auto sm:mt-0">
    </div>
  </div>

</template>
